import { userQK } from '@features/profile/model/userQK'
import { useQueryWithAuth } from '@lib/Auth/clerk-utils'
import type { UserProfileQuery } from '@purposity/sdk'
import { sdk } from '@services/sdk'
import type { UseQueryOptions } from '@tanstack/react-query'
import { useDebugValue } from 'react'
import { useAuthContext } from '~/features/auth/components/AuthProvider'

function useProfileQuery<TData = UserProfileQuery>(
  options?: UseQueryOptions<UserProfileQuery, Error, TData>
) {
  const { isLoaded, isSignedIn } = useAuthContext()

  return useQueryWithAuth({
    queryKey: userQK.profile(),
    async queryFn(context) {
      return sdk.userProfile(
        { cacheRefresh: true },
        context.meta?.headers,
        context.signal
      )
    },

    enabled: isLoaded && isSignedIn,
    ...options,
  })
}

useProfileQuery.queryKey = userQK.profile()

export { useProfileQuery }

export function useProfile() {
  const query = useProfileQuery({
    select: (data) => data.me,
  })

  useDebugValue(query.data)
  return query.data
}
